import { RouterModule, PreloadAllModules } from '@angular/router'
import { NgModule } from '@angular/core'
import { OauthCallbackGuard } from './oauth-callback/oauth-callback.guard'
import { AuthGuard, ProfGuard } from './core/_guards'
import { productionGuard } from './core/_guards/production.guard'
import { UserResolver } from './core/_resolvers/user.resolver'
import { MemberProfileResolver } from './core/_resolvers/member-profile.resolver'

export const PAGE_NAME_USER_PROFILE = 'User Profile'
export const PAGE_NAME_USER_AVAILABILITY_LIST = 'User Availability'
export const PAGE_NAME_MY_PROFILE = 'My Profile'

export const appRoutesOld = [
    {
        path: 'dashboard',
        loadChildren: () => import('./calendar/calendar.module').then((m) => m.CalendarModule),
    },
    {
        path: 'profile',
        loadChildren: () => import('./my-profile/my-profile.module').then((m) => m.MyProfileModule),
    },
    {
        path: 'user/:id',
        loadChildren: () =>
            import('./user-profile/user-profile.module').then((m) => m.UserProfileModule),
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    },
    {
        path: 'group-management',
        loadChildren: () => import('./group/group.module').then((m) => m.GroupModule),
    },
    {
        path: 'account',
        loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
    },
    {
        path: 'launch',
        loadChildren: () => import('./launch/launch.module').then((m) => m.LaunchModule),
    },
    {
        path: 'session',
        loadChildren: () => import('./launch/launch.module').then((m) => m.LaunchModule),
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
    },
    {
        path: 'signup',
        loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
    },
    {
        path: 'oauth/authorize',
        loadChildren: () => import('./oauth/oauth.module').then((m) => m.OAuthModule),
    },
    {
        path: 'oauthcallback/:provider',
        loadComponent: () =>
            import('./oauth-callback/oauth-callback.component').then(
                (m) => m.OauthCallbackComponent,
            ),
        canActivate: [OauthCallbackGuard],
    },
    {
        path: 'sessions',
        loadChildren: () =>
            import('./my-sessions/my-sessions.module').then((m) => m.MySessionsModule),
    },
    {
        path: 'people',
        loadChildren: () => import('./people/people.module').then((m) => m.PeopleModule),
    },
    {
        path: 'upgrade',
        loadChildren: () => import('./plans/plans.module').then((m) => m.PlansModule),
    },
    {
        path: 'metered/checkout',
        loadComponent: () =>
            import('./routes/checkout/checkout.component').then((m) => m.CheckoutComponent),
    },
    {
        path: 'invite',
        loadChildren: () =>
            import('./user-referral/user-referral.module').then((m) => m.UserReferralModule),
    },
    {
        path: 'refer',
        loadChildren: () =>
            import('./rewards-referral/rewards-referral.module').then(
                (m) => m.RewardsReferralModule,
            ),
    },
    {
        path: 'i/:hash',
        loadChildren: () =>
            import('./user-availability/user-availability.module').then(
                (m) => m.UserAvailabilityModule,
            ),
    },
    {
        path: 'availability',
        loadChildren: () =>
            import('./availability-lists/availability-lists.module').then(
                (m) => m.AvailabilityListsModule,
            ),
    },
    { path: '**', redirectTo: 'dashboard' },
]
export const appRoutesNewLayout = [
    {
        path: 'dashboard',
        loadComponent: () =>
            import('./routes/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [AuthGuard],
        data: { robots: 'noindex, nofollow', pageName: 'Calendar', threeColumnLayout: true },
    },
    {
        path: 'profile',
        loadComponent: () =>
            import('./routes/profile/my-profile-container/my-profile-container.component').then(
                (m) => m.MyProfileContainerComponent,
            ),
        canActivate: [ProfGuard],
        data: {
            robots: 'noindex, nofollow',
            pageName: PAGE_NAME_MY_PROFILE,
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
    },
    {
        path: 'user/:id',
        loadComponent: () =>
            import('./routes/user/profile-container/profile-container.component').then(
                (m) => m.ProfileContainerComponent,
            ),
        canActivate: [ProfGuard],
        data: {
            robots: 'noindex, nofollow',
            pageName: PAGE_NAME_USER_PROFILE,
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
    },
    {
        path: 'user/:id/availability',
        loadComponent: () =>
            import('./routes/user/availability/user-availability.component').then(
                (m) => m.UserAvailabilityListComponent,
            ),
        resolve: {
            memberProfile: MemberProfileResolver,
        },
        canActivate: [ProfGuard],
        data: {
            robots: 'noindex, nofollow',
            pageName: PAGE_NAME_USER_AVAILABILITY_LIST,
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    },
    {
        path: 'group-management',
        loadChildren: () => import('./group/group.module').then((m) => m.GroupModule),
    },
    {
        path: 'account',
        loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
    },
    {
        path: 'launch',
        loadChildren: () => import('./launch/launch.module').then((m) => m.LaunchModule),
    },
    {
        path: 'session',
        loadChildren: () => import('./launch/launch.module').then((m) => m.LaunchModule),
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
    },
    {
        path: 'signup',
        loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
    },
    {
        path: 'oauth/authorize',
        loadChildren: () => import('./oauth/oauth.module').then((m) => m.OAuthModule),
    },
    {
        path: 'oauthcallback/:provider',
        loadComponent: () =>
            import('./oauth-callback/oauth-callback.component').then(
                (m) => m.OauthCallbackComponent,
            ),
        canActivate: [OauthCallbackGuard],
        data: { threeColumnLayout: true },
    },
    {
        path: 'sessions',
        loadChildren: () =>
            import('./my-sessions/my-sessions.module').then((m) => m.MySessionsModule),
    },
    {
        path: 'people',
        loadComponent: () =>
            import('./routes/people/people-list.component').then((m) => m.PeopleListComponent),
        resolve: { currentUser: UserResolver },
        canActivate: [AuthGuard],
        data: {
            robots: 'noindex, nofollow',
            pageName: 'People List',
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
    },
    {
        path: 'upgrade',
        loadChildren: () => import('./plans/plans.module').then((m) => m.PlansModule),
    },
    {
        path: 'metered/checkout',
        loadComponent: () =>
            import('./routes/checkout/checkout.component').then((m) => m.CheckoutComponent),
    },
    {
        path: 'invite',
        loadChildren: () =>
            import('./user-referral/user-referral.module').then((m) => m.UserReferralModule),
    },
    {
        path: 'refer',
        loadComponent: () =>
            import('./routes/refer/rewards-referrals.component').then(
                (m) => m.RewardsReferralsComponent,
            ),
        data: { pageName: 'Refer', threeColumnLayout: true, hideBookingHubOnMobile: true },
        resolve: { currentUser: UserResolver },
        canActivate: [AuthGuard],
    },
    {
        path: 'settings',
        loadComponent: () =>
            import('./routes/settings/settings.component').then((m) => m.SettingsComponent),
        data: {
            robots: 'noindex, nofollow',
            pageName: 'Settings',
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
        resolve: { currentUser: UserResolver },
        canActivate: [AuthGuard],
    },
    {
        path: 'help',
        loadComponent: () =>
            import('./routes/help-and-resources/help-and-resources.component').then(
                (m) => m.HelpAndResourcesComponent,
            ),
        data: {
            robots: 'noindex, nofollow',
            pageName: 'Help & Resources',
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
        resolve: { currentUser: UserResolver },
        canActivate: [AuthGuard],
    },
    {
        path: 'help/faq',
        loadComponent: () =>
            import('./routes/help-and-resources/faq/faq.component').then((m) => m.FaqComponent),
        data: {
            robots: 'noindex, nofollow',
            pageName: 'Common Questions',
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
        resolve: { currentUser: UserResolver },
        canActivate: [AuthGuard],
    },
    {
        path: 'help/guidelines',
        loadComponent: () =>
            import('./routes/help-and-resources/guidelines/guidelines.component').then(
                (m) => m.GuidelinesComponent,
            ),
        data: {
            robots: 'noindex, nofollow',
            pageName: 'Community Guidelines',
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
        resolve: { currentUser: UserResolver },
        canActivate: [AuthGuard],
    },
    {
        path: 'i/:hash',
        loadChildren: () =>
            import('./user-availability/user-availability.module').then(
                (m) => m.UserAvailabilityModule,
            ),
    },
    {
        path: 'availability/favorites',
        loadComponent: () =>
            import('./routes/availability/favorites/favorites-list.component').then(
                (m) => m.FavoritesListComponent,
            ),
        data: {
            robots: 'noindex, nofollow',
            pageName: 'Availability: Favorites',
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
        resolve: {
            currentUser: UserResolver,
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'theme',
        loadChildren: () => import('./routes/theme/theme.routes').then((m) => m.THEME_ROUTES),
        canActivate: [productionGuard],
        data: {
            robots: 'noindex, nofollow',
            pageName: 'Theme',
            threeColumnLayout: true,
            hideBookingHubOnMobile: true,
        },
    },
    { path: '**', redirectTo: 'dashboard' },
]

let newLayout = 'f'
try {
    newLayout = localStorage.getItem('newLayout')
} catch (e) {}
const appRoutes = newLayout == 't' ? appRoutesNewLayout : appRoutesOld

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            preloadingStrategy: PreloadAllModules,
            enableTracing: false,
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
            scrollPositionRestoration: 'enabled',
            paramsInheritanceStrategy: 'always',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
